import * as React from "react";
import { Button, Dropdown, Popover } from "antd";
import { DownOutlined, InfoCircleOutlined } from "@ant-design/icons";

interface DropdownMenuFieldProps {
  title?: string;
  itemslist: { label: string; key: string }[];
  initialValue?: string;
  text?: React.ReactNode;
  onSelect: (key: string) => void;
  disabled?: boolean;
}

export default function DropdownMenuField({
  title = "",
  itemslist,
  initialValue = "",
  text,
  onSelect,
  disabled,
}: DropdownMenuFieldProps) {
  const handleMenuClick = (e: { key: string }) => {
    onSelect(e.key);
  };

  const selectedLabel = itemslist.find((item) => item.key === initialValue)?.label || "Select an option";
  const hasTitle = title && title.trim() !== "";

  const menuProps = {
    items: itemslist.map((item) => ({
      label: <span style={{ fontFamily: title === "Font Style" ? item.key : "inherit" }}>{item.label}</span>,
      key: item.key,
    })),
    onClick: handleMenuClick,
    style: {
      maxHeight: "300px",
      overflowY: "auto" as const,
    },
  };

  return (
    <div className={`${hasTitle ? "flex items-center justify-between  w-full" : " w-full"}`}>
      {hasTitle && <label className={"whitespace-nowrap text-left w-[240px]"}>{title}</label>}
      <div className={`flex items-center ${hasTitle ? "w-[65%]" : "w-full"}`}>
        <div className={`flex items-center ${hasTitle ? "w-[60%]" : "w-full"} relative overflow-hidden`}>
          <Dropdown
            menu={menuProps}
            disabled={disabled}
            trigger={["click"]}
            className={`w-full max-w-2xl ${text ? "pr-12" : ""}`}
          >
            <Button
              className={"w-full text-right flex items-center justify-between"}
              style={{
                fontFamily: title === "Font Style" && initialValue ? initialValue : "inherit",
              }}
            >
              <span className="flex-1 text-left">{selectedLabel}</span>
              <DownOutlined className="ml-2" />
            </Button>
          </Dropdown>

          {text && (
            <div
              className={
                "absolute bottom-0 right-0 py-2 px-3 flex items-center justify-center  bg-[#f5f5f5] h-full border border-solid rounded-r border-[#d9d9d9]"
              }
            >
              <Popover
                content={text}
                trigger="click"
                overlayStyle={{
                  width: "300px",
                  borderRadius: "4px",
                }}
              >
                <InfoCircleOutlined style={{ cursor: "pointer" }} />
              </Popover>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
